// Theme: transformative-teal
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'transformative-teal',
  name: 'TRANSFORMATIVE TEAL',
  tagline: 'TRANSFORMATIVE TEAL',
  description: 'Teal transformador com contraste limpo para leitura longa.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#0E3C40', '#1A5055', '#7DBFC4', '#D7F0ED'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '8px',
      '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-transformative-teal'
  },
  colorVars: {
    '--accent': '#7DBFC4',
    '--accent-foreground': '#0E3C40',
    '--background': '#0E3C40',
    '--border': '#2F8C95',
    '--card': '#1A5055',
    '--card-border-active': 'rgba(125, 191, 196, 0.35)',
    '--card-completed': '#16494D',
    '--card-foreground': '#D7F0ED',
    '--card-glow': 'rgba(125, 191, 196, 0.08)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#D7F0ED',
    '--hold-fill': '#7DBFC4',
    '--input': '#2F8C95',
    '--modal-bg': '#0E3C40',
    '--modal-border': '#2F8C95',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#2F8C95',
    '--muted-foreground': '#D7F0ED',
    '--nav-active': '#7DBFC4',
    '--nav-bg': '#1A5055',
    '--popover': '#1A5055',
    '--popover-foreground': '#D7F0ED',
    '--primary': '#7DBFC4',
    '--primary-foreground': '#0E3C40',
    '--ring': '#7DBFC4',
    '--secondary': '#2F8C95',
    '--secondary-foreground': '#D7F0ED',
    '--streak': '#7DBFC4',
    '--success': '#22c55e',
    '--success-foreground': '#0E3C40',
    '--xp': '#7DBFC4',
    '--xp-bg': '#1A5055'
  },
  resolvedVars: {
    '--accent': '#7DBFC4',
    '--accent-foreground': '#0E3C40',
    '--accent-foreground-hsl': '185 64% 15%',
    '--accent-foreground-oklch': 'from #0E3C40 l c h',
    '--accent-hsl': '184 38% 63%',
    '--accent-oklch': 'from #7DBFC4 l c h',
    '--background': '#0E3C40',
    '--background-hsl': '185 64% 15%',
    '--background-oklch': 'from #0E3C40 l c h',
    '--border': '#2F8C95',
    '--border-hsl': '185 52% 38%',
    '--border-oklch': 'from #2F8C95 l c h',
    '--border-w': '1px',
    '--card': '#1A5055',
    '--card-border-active': 'rgba(125, 191, 196, 0.35)',
    '--card-completed': '#16494D',
    '--card-completed-hsl': '184 56% 19%',
    '--card-completed-oklch': 'from #16494D l c h',
    '--card-foreground': '#D7F0ED',
    '--card-foreground-hsl': '173 45% 89%',
    '--card-foreground-oklch': 'from #D7F0ED l c h',
    '--card-glow': 'rgba(125, 191, 196, 0.08)',
    '--card-hsl': '185 53% 22%',
    '--card-oklch': 'from #1A5055 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D7F0ED',
    '--foreground-hsl': '173 45% 89%',
    '--foreground-oklch': 'from #D7F0ED l c h',
    '--hold-fill': '#7DBFC4',
    '--hold-fill-hsl': '184 38% 63%',
    '--hold-fill-oklch': 'from #7DBFC4 l c h',
    '--input': '#2F8C95',
    '--input-hsl': '185 52% 38%',
    '--input-oklch': 'from #2F8C95 l c h',
    '--modal-bg': '#0E3C40',
    '--modal-bg-hsl': '185 64% 15%',
    '--modal-bg-oklch': 'from #0E3C40 l c h',
    '--modal-border': '#2F8C95',
    '--modal-border-hsl': '185 52% 38%',
    '--modal-border-oklch': 'from #2F8C95 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--muted': '#2F8C95',
    '--muted-foreground': '#D7F0ED',
    '--muted-foreground-hsl': '173 45% 89%',
    '--muted-foreground-oklch': 'from #D7F0ED l c h',
    '--muted-hsl': '185 52% 38%',
    '--muted-oklch': 'from #2F8C95 l c h',
    '--nav-active': '#7DBFC4',
    '--nav-active-hsl': '184 38% 63%',
    '--nav-active-oklch': 'from #7DBFC4 l c h',
    '--nav-bg': '#1A5055',
    '--nav-bg-hsl': '185 53% 22%',
    '--nav-bg-oklch': 'from #1A5055 l c h',
    '--popover': '#1A5055',
    '--popover-foreground': '#D7F0ED',
    '--popover-foreground-hsl': '173 45% 89%',
    '--popover-foreground-oklch': 'from #D7F0ED l c h',
    '--popover-hsl': '185 53% 22%',
    '--popover-oklch': 'from #1A5055 l c h',
    '--primary': '#7DBFC4',
    '--primary-foreground': '#0E3C40',
    '--primary-foreground-hsl': '185 64% 15%',
    '--primary-foreground-oklch': 'from #0E3C40 l c h',
    '--primary-hsl': '184 38% 63%',
    '--primary-oklch': 'from #7DBFC4 l c h',
    '--radius': '8px',
    '--ring': '#7DBFC4',
    '--ring-hsl': '184 38% 63%',
    '--ring-oklch': 'from #7DBFC4 l c h',
    '--secondary': '#2F8C95',
    '--secondary-foreground': '#D7F0ED',
    '--secondary-foreground-hsl': '173 45% 89%',
    '--secondary-foreground-oklch': 'from #D7F0ED l c h',
    '--secondary-hsl': '185 52% 38%',
    '--secondary-oklch': 'from #2F8C95 l c h',
    '--shadow-card': '0 8px 20px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 24px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#7DBFC4',
    '--streak-hsl': '184 38% 63%',
    '--streak-oklch': 'from #7DBFC4 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0E3C40',
    '--success-foreground-hsl': '185 64% 15%',
    '--success-foreground-oklch': 'from #0E3C40 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(184 38% 63% / 0.15)',
    '--xp': '#7DBFC4',
    '--xp-bg': '#1A5055',
    '--xp-bg-hsl': '185 53% 22%',
    '--xp-bg-oklch': 'from #1A5055 l c h',
    '--xp-hsl': '184 38% 63%',
    '--xp-oklch': 'from #7DBFC4 l c h'
  }
}
